import { render, staticRenderFns } from "./TableauBord.vue?vue&type=template&id=9b54af02&"
import script from "./TableauBord.vue?vue&type=script&lang=js&"
export * from "./TableauBord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports